import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { ShoppingCart, User, Menu, X, Leaf, Sparkles, MessageCircle, Heart } from "lucide-react";
import { Button } from "../components/ui/button";
import NotificationBell from "../components/NotificationBell";

const Navbar = ({ showFullNav = true }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="bg-white border-b border-[#EAE6DF] sticky top-0 z-50" data-testid="main-navbar">
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "0 24px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: "64px" }}>

          {/* Left group: Logo + Nav links */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <Link to="/" style={{ flexShrink: 0, marginRight: "2rem", display: "flex", alignItems: "center" }}>
              <img src="/logo-transparent.png" alt="ARKY World" style={{ height: "45px", width: "auto" }} />
            </Link>

            {showFullNav && (
              <div className="hidden md:flex" style={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center", gap: "2rem" }}>
                <Link to="/products" className="hidden md:inline-flex text-[#5C5D5C] hover:text-[#1A1B1A] transition-colors font-light whitespace-nowrap items-center">
                  Shop
                </Link>
                <Link to="/products?eco_only=true" className="hidden md:inline-flex text-[#5C5D5C] hover:text-[#1A1B1A] transition-colors font-light whitespace-nowrap items-center gap-1">
                  <Leaf size={16} /> Eco
                </Link>
                <Link to="/ai-visualizer" className="hidden md:inline-flex text-[#5C5D5C] hover:text-[#1A1B1A] transition-colors font-light whitespace-nowrap items-center gap-1">
                  <Sparkles size={16} /> AI Visualiser
                </Link>
                <Link to="/ai-chat" className="hidden md:inline-flex text-[#5C5D5C] hover:text-[#1A1B1A] transition-colors font-light whitespace-nowrap items-center gap-1" style={{ paddingRight: "20px" }}>
                  <MessageCircle size={16} /> Design Chat
                </Link>
              </div>
            )}
          </div>

          {/* Right group: Actions */}
          <div className="hidden md:flex" style={{ flexShrink: 0, alignItems: "center", gap: "12px" }}>
            {user ? (
              <>
                <NotificationBell />
                <Link to="/cart" className="p-2 text-[#5C5D5C] hover:text-[#1A1B1A] transition-colors" data-testid="cart-link">
                  <ShoppingCart size={20} />
                </Link>
                <Link to="/wishlist" className="p-2 text-[#5C5D5C] hover:text-[#1A1B1A] transition-colors" data-testid="wishlist-link">
                  <Heart size={20} />
                </Link>
                <Link to="/dashboard" className="p-2 text-[#5C5D5C] hover:text-[#1A1B1A] transition-colors" data-testid="dashboard-link">
                  <User size={20} />
                </Link>
                <Button
                  variant="ghost"
                  onClick={logout}
                  className="text-[#5C5D5C] hover:text-[#1A1B1A]"
                  data-testid="logout-btn"
                >
                  Logout
                </Button>
              </>
            ) : (
              <Button
                onClick={() => navigate("/auth")}
                className="bg-[#20C997] hover:bg-[#1AAE82] text-white rounded-none px-6"
                data-testid="login-btn"
              >
                Sign In
              </Button>
            )}
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden py-4 border-t border-[#EAE6DF]">
            <div className="flex flex-col gap-4">
              <Link to="/products" className="text-[#5C5D5C] hover:text-[#1A1B1A]">Shop</Link>
              <Link to="/products?eco_only=true" className="text-[#5C5D5C] hover:text-[#1A1B1A]">Eco Products</Link>
              <Link to="/ai-visualizer" className="text-[#5C5D5C] hover:text-[#1A1B1A]">AI Visualiser</Link>
              <Link to="/ai-chat" className="text-[#5C5D5C] hover:text-[#1A1B1A]">Design Chat</Link>
              {user ? (
                <>
                  <Link to="/cart" className="text-[#5C5D5C] hover:text-[#1A1B1A]">Cart</Link>
                  <Link to="/wishlist" className="text-[#5C5D5C] hover:text-[#1A1B1A]">Favourites</Link>
                  <Link to="/dashboard" className="text-[#5C5D5C] hover:text-[#1A1B1A]">Dashboard</Link>
                  <button onClick={logout} className="text-left text-[#5C5D5C] hover:text-[#1A1B1A]">Logout</button>
                </>
              ) : (
                <Link to="/auth" className="text-[#20C997] font-medium">Sign In</Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
